/**
 * Chapter title scene renderer
 */

import type { SceneData, SceneConfig } from '../types'

export interface ChapterTitleRendererContext {
  container: HTMLDivElement
  data: SceneData
  config: SceneConfig
  onAudioSetup?: (container: HTMLDivElement) => void
}

/**
 * Render chapter title scene
 * @returns The chapter title container element (not the main container)
 */
export function renderChapterTitle(context: ChapterTitleRendererContext): HTMLDivElement {
  const { container, data, config, onAudioSetup } = context

  // Apply margin from config (1 unit = 1vh) with svh/vh fallback
  const marginVh = config.chapterTitle.margin
  // Set both svh and vh - browsers that support svh will use it, others will use vh
  container.style.marginTop = `${marginVh}svh`
  if (!CSS.supports('margin-top', `${marginVh}svh`)) {
    container.style.marginTop = `${marginVh}vh`
  }
  container.style.marginBottom = `${marginVh}svh`
  if (!CSS.supports('margin-bottom', `${marginVh}svh`)) {
    container.style.marginBottom = `${marginVh}vh`
  }

  // Create chapter title container
  const chapterContainer = document.createElement('div')
  chapterContainer.className = 'chapter-title-scene__container'

  // Create text element
  const textElement = document.createElement('div')
  textElement.className = 'chapter-title-scene__text text-chapter'
  textElement.textContent = data.text || data.id

  chapterContainer.appendChild(textElement)
  container.appendChild(chapterContainer)

  // Setup audio if callback provided
  if (onAudioSetup) {
    onAudioSetup(chapterContainer)
  }

  return chapterContainer
}
